import React, { useEffect } from "react";
import { checkBrowser } from "../../Helpers/addToHomeScreen";
import { connect } from "react-redux";
import { setFirstVisit } from "../../Redux/Actions";
import { useHistory } from "react-router-dom";
import { ReactComponent as Dots } from "../../assets/icons/shapes-and-symbols.svg";
import { ReactComponent as Plus } from "../../assets/icons/signs.svg";
import { ReactComponent as Share } from "../../assets/icons/multimedia-option.svg";
import { ReactComponent as Home } from "../../assets/icons/arrow.svg";
import { ReactComponent as IOSArrow } from "../../assets/icons/curved.svg";

const AddToHome = ({ isLogin, setVisit }) => {
  const browser = checkBrowser();
  const history = useHistory();
  const standalone = window.matchMedia("(display-mode: standalone)").matches;
  useEffect(() => {
    setVisit();
    if (!standalone) {
      if (isLogin) {
        history.push("/Main");
      } else {
        history.push("/Login");
      }
    }
  }, []);
  const onPress = () => {
    setVisit();
  };

  const text = () => {
    if (browser.isMobile && browser.chromeAgent) {
      return (
        <div className="AddToHomeDesc">
          <div
            style={{
              padding: window.innerWidth * 0.01,
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              direction: "rtl",
            }}
          >
            <span>1- ابتدا علامت </span>
            <Dots width={window.innerWidth * 0.025} height={"auto"} />{" "}
            <span>را فشار دهید</span>
          </div>
          <div
            style={{
              padding: window.innerWidth * 0.01,
              display: "flex",
              // width: "50%",
              flexDirection: "column",

              alignItems: "center",
              direction: "rtl",
            }}
          >
            <span style={{ direction: "rtl", textAlign: "right" }}>
              2- سپس گزینه Add to Home screen را انتخاب کنید
            </span>
            <span style={{ direction: "rtl", textAlign: "right" }}>
              3- در نهایت با زدن دکمه Add برنامه به صفحه اصلی گوشی اضافه میشود
            </span>
          </div>
        </div>
      );
    } else if (browser.isMobile && browser.firefoxAgent) {
      return (
        <div className="AddToHomeDesc">
          <div
            style={{
              padding: window.innerWidth * 0.01,
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              direction: "rtl",
            }}
          >
            <span>{`1- علامت `}</span>
            <Home
              fill={"white"}
              color={"white"}
              width={window.innerWidth * 0.045}
              height={"auto"}
              style={{
                marginRight: window.innerWidth * 0.01,
                marginLeft: window.innerWidth * 0.01,
              }}
            />
            <span>را فشار دهید </span>
          </div>
          <div
            style={{
              padding: window.innerWidth * 0.01,
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              direction: "rtl",
            }}
          >
            <span style={{ direction: "rtl", textAlign: "right" }}>
              2- دکمه Add To Home Screen را فشار دهید
            </span>
          </div>
        </div>
      );
    } else if (!browser.isMobile) {
      return (
        <div className="AddToHomeDesc">
          <div
            style={{
              padding: window.innerWidth * 0.01,
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              direction: "rtl",
            }}
          >
            <span>{`1- ابتدا علامت  `}</span>
            <Plus
              width={window.innerWidth * 0.015}
              height={"auto"}
              style={{
                marginRight: window.innerWidth * 0.01,
                marginLeft: window.innerWidth * 0.01,
              }}
            />
            <span>را فشار دهید </span>
          </div>
          <div
            style={{
              padding: window.innerWidth * 0.01,
              display: "flex",
              // width: "50%",
              flexDirection: "column",
              justifyContent: "flex-end",
              alignItems: "center",
              direction: "rtl",
            }}
          >
            <span style={{ direction: "rtl", textAlign: "right" }}>
              2- سپس گزینه install را انتخاب نمایید
            </span>
            <span style={{ direction: "rtl", textAlign: "right" }}>
              3- برنامه باز شده را بسته و از طریق صفحه اصلی و یا منوی استارت
              برنامه را اجرا نمایید
            </span>
          </div>
        </div>
      );
    } else if (browser.isIOS) {
      return (
        <div className="AddToHomeDesc">
          <div
            style={{
              padding: window.innerWidth * 0.01,
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              direction: "rtl",
            }}
          >
            <span>{`1- ابتدا علامت  `}</span>
            <Share
              width={window.innerWidth * 0.045}
              height={"auto"}
              style={{
                marginRight: window.innerWidth * 0.01,
                marginLeft: window.innerWidth * 0.01,
              }}
            />
            <span>را فشار دهید </span>
          </div>
          <div
            style={{
              padding: window.innerWidth * 0.01,
              display: "flex",
              // width: "50%",
              flexDirection: "row",

              alignItems: "center",
              direction: "rtl",
            }}
          >
            <span style={{ direction: "rtl", textAlign: "right" }}>
              2- سپس با انتخاب گزینه Add To HomeScreen برنامه را به صفحه اصلی
              گوشی خود اضافه نمایید
            </span>
          </div>
        </div>
      );
    } else
      return (
        <span style={{ direction: "rtl", textAlign: "right" }}>
          با زدن دکمه Add To Home Screen در مرورگر، میتوانید برنامه را نصب
          نمایید
        </span>
      );
  };
  return (
    <div className="Container">
      <div className="mobileContainer">
        <div className="AddToHomePage">
          <img
            src={require("../../assets/images/SplashLogo.png")}
            id="AboutImage"
          />
          <span
            style={{ color: "#ec4d11", marginBottom: window.innerHeight * 0.1 }}
          >
            راهنمای اضافه کردن وب اپلیکیشن به صفحه اصلی
          </span>
          {text()}
          {browser.isMobile &&
            browser.isIOS &&
            !browser.chromeAgent &&
            !browser.firefoxAgent && (
              <div
                style={{
                  width: window.innerWidth,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  position: "absolute",
                  bottom: window.innerHeight * 0.075,
                }}
                id="AnimateDivInfinite"
              >
                <IOSArrow
                  className="A2hsSvgIOS"
                  fill="#ec4d11"
                  // width={window.innerWidth * 0.025}
                  // height={window.innerheight * 0.025}
                />
              </div>
            )}
          {browser.isMobile && browser.chromeAgent && (
            <div
              id="AnimateDivInfinite"
              style={{
                width: window.innerWidth,
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-end",
                paddingRight: window.innerWidth * 0.05,
                position: "absolute",
                top: 0,
              }}
            >
              <IOSArrow
                className="A2hsSvgAndroid"
                fill="#ec4d11"
                // width={window.innerWidth * 0.05}
                // height={window.innerheight * 0.05}
              />
            </div>
          )}
          {browser.isMobile && browser.firefoxAgent && (
            <div
              id="AnimateDivInfinite"
              style={{
                width: window.innerWidth,
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-end",
                paddingRight: window.innerWidth * 0.05,
                position: "absolute",
                top: 0,
              }}
            >
              <IOSArrow
                className="A2hsSvgAndroidF"
                fill="#ec4d11"
                // width={window.innerWidth * 0.05}
                // height={window.innerheight * 0.05}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
const mapStateToProps = (state) => {
  return {
    isLogin: state.auth.isLogin,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    setVisit: () => dispatch(setFirstVisit(false)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(AddToHome);
